module.exports = __webpack_public_path__ + "VA shaded1.png?4999ece0ee0db07e382f2163aca60498";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/VA shaded1.png
// module id = 61
// module chunks = 0